module.exports = __webpack_public_path__ + "img/jobbliss_logo.d3a98bdb.png";